import List from "@/components/list";
// import router from "@/router";

const Table = args => {
  const { listeners } = args;
  const recovery = listeners["recovery"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let dealConf = [

    ];

    // if (vo.row.delType === 1) {
    //   dealConf.push(
    //     [
    //       "icon-restore-disabled",
    //       "恢复",
    //       () => { },
    //       "user:repair"
    //     ]
    //   )
    // } else {
      dealConf.push(
        [
          "icon-restore",
          "恢复",
          () => {
            recovery(vo.row);
          },
          "user:repair"
        ]
      )
    // }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const tableConfig = [
    /*  {
       type: "selection",
       label: "main"
     }, */
    {
      label: "姓名",
      prop: "userName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "单位",
      prop: "deptName",
      minWidth: "110",
      showOverflowTooltip: true
    },
    {
      label: "职级",
      prop: "positionLevelName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "100"
    },
    {
      label: "管理主体",
      prop: "leaderTypeName",
      minWidth: "100"
    },
    {
      label: "考核用户",
      prop: "isExamName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "用户状态",
      prop: "userStatusName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    // {
    //   label: "账号状态",
    //   prop: "accountStatusName"
    // },
    {
      label: "是否临时用户",
      prop: "isTempName"
    },
    {
      label: "回收类型",
      prop: "delTypeName"
    },
    {
      label: "备注",
      prop: "remark"
    },
    {
      label: "操作",
      width: "60",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return <List {...args} talbeCols={tableConfig} />;
};

export default Table;
